import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "contentDv" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_ctx.portfolioData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["itemPortfolioDv", { selectedOutline: _ctx.isSelected && !_ctx.canRemove }]),
        style: _normalizeStyle({
      background: _ctx.portfolioData.color,
    })
      }, [
        _createElementVNode("img", {
          class: "backgroundBackDv",
          src: _ctx.getImageUrl('icon-portfolio-background.png')
        }, null, 8, _hoisted_1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              crossorigin: "anonymous",
              src: _ctx.getImageUrl(_ctx.portfolioData.image, _ctx.portfolioData.directory)
            }, null, 8, _hoisted_3)
          ]),
          (_ctx.shouldShowTooltip)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "dark",
                content: _ctx.portfolioData.category,
                placement: "top-start"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", {
                    ref: "textElement",
                    class: "text",
                    onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkOverflow && _ctx.checkOverflow(...args)))
                  }, _toDisplayString(_ctx.portfolioData.category ?? "-"), 545)
                ]),
                _: 1
              }, 8, ["content"]))
            : (_openBlock(), _createElementBlock("h2", {
                key: 1,
                ref: "textElement",
                class: "text",
                onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkOverflow && _ctx.checkOverflow(...args)))
              }, _toDisplayString(_ctx.portfolioData.category ?? "-"), 545))
        ]),
        (_ctx.canRemove)
          ? (_openBlock(), _createBlock(_component_IconComponent, {
              key: 0,
              icon: "minus.svg",
              class: "remove-icon",
              id: `minus${_ctx.index}`,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onRemove()))
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ], 6))
    : _createCommentVNode("", true)
}